import { useGetActivityPointSeasonsQuery } from 'queries/activityPoint/useGetActivityPointSeasonsQuery';
import { useMemo } from 'react';
import { DateTime } from 'luxon';

export const useActivityPointSeason = () => {
  const { data: seasonsData, isPending } = useGetActivityPointSeasonsQuery();

  const targetAt = DateTime.now().set({ minute: 0, second: 0, millisecond: 0 });
  const { currentSeason, seasons } = useMemo(
    () => ({
      currentSeason: seasonsData?.seasons?.find(
        season =>
          DateTime.fromJSDate(new Date(season.startAt)) <= targetAt &&
          targetAt < DateTime.fromJSDate(new Date(season.endAt)),
      ),
      seasons: seasonsData?.seasons ?? [],
    }),
    [seasonsData?.seasons, targetAt],
  );

  return { isPending, currentSeason, seasons };
};
